import Index from "@/views/index/Index.vue"
import {report,detail} from './report'
import {appointment} from './appoint'
import {charge} from './charge'
import {clinic} from './clinic'
import {inspectitem} from './inspection'
import {outsidesettle} from './outsidesettle'
import {patientmanager,patientdetail,addpatient} from './patient'
import {pharmacy} from './pharmacy'
import {statistics} from './statistics'
import {systemmanager} from './system'
import {reportdetail} from './common'
import {samp} from './samp'
import {casemanage} from './casemanage'
// import { inspect } from "util";
// import { patientlist } from "./clinic/patientlist"
import { patient } from "./patient"
import {appointments} from './appointments'
export const index = {
  path: '/index',
  name: 'Index',
  component: Index,
  children:[
    report,detail,appointment,
    charge,clinic,inspectitem,
    outsidesettle,patientmanager,pharmacy,
    statistics,systemmanager,
    patientdetail,addpatient,reportdetail,
    samp,casemanage,patient,appointments
  ]
}



// WEBPACK FOOTER //
// ./src/router/index/index.js